import React from 'react';
import { twMerge } from 'tailwind-merge';
interface WindowFrameProps {
  title: string;
  context?: string;
  className?: string;
  bodyClassName?: string;
  children: React.ReactNode;
}

/** Frosted application window used for every product scene. */
export function WindowFrame({
  title,
  context,
  className,
  bodyClassName,
  children
}: WindowFrameProps) {
  return <div className={twMerge('glass-strong overflow-hidden rounded-[22px] shadow-window', className)} data-id="element-482" data-mp="33m7oghup5tta">
      <div className="flex h-11 items-center gap-3 border-b border-ink/[0.06] px-4" data-id="element-483" data-mp="7bxj0npgenr">
        <div className="flex gap-1.5" aria-hidden="true" data-id="element-484" data-mp="5hbfj0p6gi3">
          <span className="h-2.5 w-2.5 rounded-full bg-ink/[0.12]" data-id="element-485" data-mp="3rcboygcl9dg2" />
          <span className="h-2.5 w-2.5 rounded-full bg-ink/[0.12]" data-id="element-486" data-mp="3mf1qycb4vtgm" />
          <span className="h-2.5 w-2.5 rounded-full bg-ink/[0.12]" data-id="element-487" data-mp="3mgwdfv21ztmt" />
        </div>
        <div className="flex min-w-0 flex-1 items-center gap-2 text-xs" data-id="element-488" data-mp="2fzrd76b7waff">
          <span className="truncate font-medium text-ink" data-id="element-489" data-mp="2aybuvm0fci0q">{title}</span>
          {context ? <span className="hidden truncate text-ink-muted sm:inline" data-id="element-490" data-mp="208zaf3mcy3nf">· {context}</span> : null}
        </div>
        <span className="whitespace-nowrap rounded-full border border-ink/[0.08] bg-white/70 px-2 py-0.5 text-[10px] font-medium text-ink-muted" data-id="element-491" data-mp="257aknfgkeg66">
          Sample data
        </span>
      </div>
      <div className={bodyClassName} data-id="element-492" data-mp="1v9cx6u6j4nem">{children}</div>
    </div>;
}